import styled from "@emotion/styled";

export const Container = styled.div`
  .avatar img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px;
  }

  .summary {
    min-height: 100px;
    max-height: 500px;
    overflow-y: auto;
    margin-bottom: 20px;
  }
  .order-summary-table {
    width: 100%;
    max-width: 600px;
    margin-bottom: 10px;
    td {
      padding: 3px 0;
    }
  }
  
  .checkout-form{
    max-width: 600px;
  }
  
  .ReactVirtualized__Table__row {
    border-bottom: 1px solid #e0e0e0;
  }
  .highlight {
    background-color: #fafafa;
  }
`;

export const Quantity = styled.div`
  display: flex;
  align-items: center;
  > div {
    margin-right: 5px;
  }
  .btns {
    button.ant-btn {
      margin-right: 5px;
      padding: 0 5px;
    }
  }
`;

export const Checkout = styled.div`
  .ant-radio-group {
    display: flex;
    flex-direction: column;

    .ant-radio-wrapper {
      margin-bottom: 8px;
    }
  }
  .address {
    margin-bottom: 20px;
    .ant-form-item {
      margin-bottom: 10px;
    }
  }
`;
